"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _main = _interopRequireDefault(require("../menu/main.sync"));

var _zod = require("zod");

var _UserContext = require("../../shared/services/UserContext");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _index = _interopRequireDefault(require("../client-component/index.server"));

var _Dropdown = _interopRequireDefault(require("../User/Dropdown"));

var _SearchForm = _interopRequireDefault(require("../algolia/components/SearchForm"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'navigation_bar';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-navigation_bar';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.undefined();

exports.config = config;

function shouldShowSearch(props) {
  return !props.displaySearchInHero && !props.isSiteIndex;
}

var NavigationBar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NavigationBar, _Component);

  var _super = _createSuper(NavigationBar);

  function NavigationBar() {
    (0, _classCallCheck2.default)(this, NavigationBar);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(NavigationBar, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          forumId = _this$props.forumId,
          privateMessageEnabled = _this$props.privateMessageEnabled,
          menuMainPhrases = _this$props.menuMainPhrases,
          isTopicNewPage = _this$props.isTopicNewPage;
      var newTopicURL = forumId ? "/topic/new?fid=".concat(forumId) : '/topic/new';
      var searchVisible = shouldShowSearch(this.props);

      var searchForm = function searchForm(isUserGuest) {
        return (0, _index.default)(_SearchForm.default, 'algolia/components/SearchForm', {
          isUserGuest: isUserGuest,
          isFederatedSalesforceSearch: _this.props.isFederatedSalesforceSearch,
          isFederatedSkilljarSearch: _this.props.isFederatedSkilljarSearch,
          isFederatedFreshdeskSearch: _this.props.isFederatedFreshdeskSearch
        });
      };

      return (0, _preact.h)(_UserContext.CurrentUserContext.Consumer, null, function (user) {
        var isGuest = !user.id;
        return (0, _preact.h)("nav", {
          className: (0, _classnames.default)('main-navigation--wrapper', 'qa-main-navigation', 'custom-navigation'),
          "data-entity": "NavigationBar"
        }, (0, _preact.h)("div", {
          className: "main-navigation-sitewidth"
        }, (0, _index.default)(_main.default, 'menu/main', _objectSpread({
          communityCategories: _this.props.categoryGroups,
          knowledgeBaseCategories: _this.props.knowledgeBaseCategories,
          showActivitySinceLastVisit: !!user.id
        }, menuMainPhrases ? {
          phrases: menuMainPhrases
        } : {})), searchVisible && (0, _preact.h)("section", {
          className: "main-navigation--search-wrapper is-hidden-mobile-only"
        }, searchForm(isGuest)), (0, _preact.h)("section", {
          className: "main-navigation--nav-buttons-wrapper"
        }, (0, _preact.h)("ul", null, !isTopicNewPage && (0, _preact.h)("li", {
          className: "is-hidden-S"
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(newTopicURL),
          "data-track": JSON.stringify({
            trigger: 'navigation',
            type: 'Topic Initiated'
          }),
          "data-ga-track": JSON.stringify({
            eventCategory: 'Homepage',
            eventAction: 'Create topic clicked',
            eventLabel: {
              Position: 'Navigation'
            }
          }),
          className: (0, _classnames.default)('link', 'menu-create-topic', 'qa-menu-create-topic'),
          tabIndex: 0,
          role: "button"
        }, (0, _preact.h)("span", {
          className: "icon--pen icon--auto-width",
          "aria-hidden": "true"
        }), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
          p: "main.navigation.add_topic"
        })))), isGuest ? (0, _preact.h)("li", null, _this.props.ssoLoginUrl ? (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(_this.props.ssoLoginUrl),
          tabIndex: 0,
          role: "button",
          className: "link qa-header-login-button"
        }, (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "main.navigation.login"
        })) : (0, _preact.h)("a", {
          href: "#",
          className: (0, _classnames.default)('link', 'js-open-modal', 'qa-header-login-button'),
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return window.app.events.commands.execute('modal:login:show');
          }
        }, (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "main.navigation.login"
        }))) : (0, _preact.h)(_Dropdown.default, (0, _extends2.default)({}, user, {
          size: "S",
          pmNotificationHref: privateMessageEnabled ? '/inbox/overview' : undefined
        }))))), searchVisible && (0, _preact.h)("div", {
          className: (0, _classnames.default)('sitewidth', 'sitewidth--search-wrapper', 'is-hidden-tablet-up')
        }, (0, _preact.h)("section", {
          className: "main-navigation--search-wrapper"
        }, searchForm(isGuest))));
      });
    }
  }]);
  return NavigationBar;
}(_preact.Component);

var _default = NavigationBar;
exports.default = _default;